//Getters
export const ZIPCODE = 'shared/ZIPCODE';
export const CONTAINER_LIST = 'shared/CONTAINER_LIST';
export const CART_LIST = 'shared/CART_LIST';
export const TYPE = 'shared/TYPE';
export const PURPOSE = 'shared/PURPOSE';
export const DELIVERY = 'shared/DELIVERY';
export const CSC_TERMS = 'shared/CSC_TERMS';
export const CSC_SURVEY = 'shared/CSC_SURVEY';
export const CURRENTSURVEYOBJECT = 'shared/CURRENTSURVEYOBJECT';
export const TERMSCHECKBOX = 'shared/TERMSCHECKBOX';
export const LINEITEMHAULERPRICE = 'shared/LINEITEMHAULERPRICE';
export const LINEITEMMARKET = 'shared/LINEITEMMARKET';
export const PREDELIVERYANSWERS = 'shared/PREDELIVERYANSWERS';
export const DELIVERY_DOORDIRECTION = 'shared/DELIVERY_DOORDIRECTION';
export const DELIVERY_SPACE = 'shared/DELIVERY_SPACE';
export const DELIVERY_RUSTACKNOWLEDGE = 'shared/DELIVERY_RUSTACKNOWLEDGE';
export const DELIVERY_INSTRUCTIONS = 'shared/DELIVERY_INSTRUCTIONS';
export const DELIVERY_NAME = 'shared/DELIVERY_NAME';
export const DELIVERY_PHONE = 'shared/DELIVERY_PHONE';
export const DELIVERY_FIRSTACCEPTABLEDATE = 'shared/DELIVERY_FIRSTACCEPTABLEDATE';
export const DELIVERY_NONACCEPTABLEDATES = 'shared/DELIVERY_NONACCEPTABLEDATES';
export const DELIVERY_SURFACETYPE = 'shared/DELIVERY_SURFACETYPE';
export const DELIVERY_SOFTSURFACEACKNOWLEDGE = 'shared/DELIVERY_SOFTSURFACEACKNOWLEDGE';
export const PREPICKUPANSWERS = 'shared/PREPICKUPANSWERS';
export const PICKUP_RUSTACKNOWLEDGE = 'shared/PICKUP_RUSTACKNOWLEDGE';
export const PICKUP_INSPECTION = 'shared/PICKUP_INSPECTION';
export const PICKUP_INSTRUCTIONS = 'shared/PICKUP_INSTRUCTIONS';
export const PICKUP_NAME = 'shared/PICKUP_NAME';
export const FEEDBACKGIVEN = 'shared/FEEDBACKGIVEN';
export const COUNTRYCODE = 'shared/COUNTRYCODE';

//Mutations
export const MUTATE_UPDATE_ZIPCODE = 'shared/MUTATE_UPDATE_ZIPCODE';
export const MUTATE_UPDATE_CONTAINER_LIST = 'shared/MUTATE_UPDATE_CONTAINER_LIST';
export const MUTATE_UPDATE_CART_LIST = 'shared/MUTATE_UPDATE_CART_LIST';
export const MUTATE_UPDATE_CART_CUSTOMATTRIBUTE = 'shared/MUTATE_UPDATE_CART_CUSTOMATTRIBUTE';
export const MUTATE_UPDATE_CART_CSCSURVEY= 'shared/MUTATE_UPDATE_CART_CSCSURVEY';
export const MUTATE_DELETE_CART_CSCSURVEY= 'shared/MUTATE_DELETE_CART_CSCSURVEY';
export const MUTATE_REMOVE_CARTITEM = 'shared/MUTATE_REMOVE_CARTITEM';
export const MUTATE_UPDATE_RESETCART = 'shared/MUTATE_UPDATE_RESETCART';
export const MUTATE_UPDATE_TYPE = 'shared/MUTATE_UPDATE_TYPE';
export const MUTATE_UPDATE_PURPOSE = 'shared/MUTATE_UPDATE_PURPOSE';
export const MUTATE_UPDATE_DELIVERY = 'shared/MUTATE_UPDATE_DELIVERY';
export const MUTATE_UPDATE_CSC_TERMS = 'shared/MUTATE_UPDATE_CSC_TERMS';
export const MUTATE_UPDATE_CSC_SURVEY = 'shared/MUTATE_UPDATE_CSC_SURVEY';
export const MUTATE_UPDATE_CURRENTSURVEYOBJECT = 'shared/MUTATE_UPDATE_CURRENTSURVEYOBJECT';
export const MUTATE_UPDATE_CURRENTSURVEY_PURPOSE = 'shared/MUTATE_UPDATE_CURRENTSURVEY_PURPOSE';
export const MUTATE_UPDATE_CURRENTSURVEY_TYPE = 'shared/MUTATE_UPDATE_CURRENTSURVEY_TYPE';
export const MUTATE_UPDATE_TERMSCHECKBOX = 'shared/MUTATE_UPDATE_TERMSCHECKBOX';
export const MUTATE_UPDATE_LINEITEMHAULERPRICE = 'shared/MUTATE_UPDATE_LINEITEMHAULERPRICE';
export const MUTATE_UPDATE_LINEITEMMARKET = 'shared/MUTATE_UPDATE_LINEITEMMARKET';
export const MUTATE_UPDATE_PREDELIVERYANSWERS = 'shared/MUTATE_UPDATE_PREDELIVERYANSWERS';
export const MUTATE_UPDATE_DELIVERY_DOORDIRECTION = 'shared/MUTATE_UPDATE_DELIVERY_DOORDIRECTION';
export const MUTATE_UPDATE_DELIVERY_SPACE = 'shared/MUTATE_UPDATE_DELIVERY_SPACE';
export const MUTATE_UPDATE_DELIVERY_RUSTACKNOWLEDGE = 'shared/MUTATE_UPDATE_DELIVERY_RUSTACKNOWLEDGE';
export const MUTATE_UPDATE_DELIVERY_INSTRUCTIONS = 'shared/MUTATE_UPDATE_DELIVERY_INSTRUCTIONS';
export const MUTATE_UPDATE_DELIVERY_NAME = 'shared/MUTATE_UPDATE_DELIVERY_NAME';
export const MUTATE_UPDATE_DELIVERY_PHONE = 'shared/MUTATE_UPDATE_DELIVERY_PHONE';
export const MUTATE_UPDATE_DELIVERY_NONACCEPTABLEDATES = 'shared/MUTATE_UPDATE_DELIVERY_NONACCEPTABLEDATES';
export const MUTATE_UPDATE_DELIVERY_SURFACETYPE = 'shared/MUTATE_UPDATE_DELIVERY_SURFACETYPE';
export const MUTATE_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE = 'shared/MUTATE_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE';
export const MUTATE_UPDATE_PREPICKUPANSWERS = 'shared/MUTATE_UPDATE_PREPICKUPANSWERS';
export const MUTATE_UPDATE_PICKUP_RUSTACKNOWLEDGE = 'shared/MUTATE_UPDATE_PICKUP_RUSTACKNOWLEDGE';
export const MUTATE_UPDATE_PICKUP_INSPECTION = 'shared/MUTATE_UPDATE_PICKUP_INSPECTION';
export const MUTATE_UPDATE_PICKUP_INSTRUCTIONS = 'shared/MUTATE_UPDATE_PICKUP_INSTRUCTIONS';
export const MUTATE_UPDATE_PICKUP_NAME = 'shared/MUTATE_UPDATE_PICKUP_NAME';
export const MUTATE_UPDATE_FEEDBACKGIVEN = 'shared/MUTATE_UPDATE_FEEDBACKGIVEN';
export const MUTATE_UPDATE_COUNTRYCODE = 'shared/MUTATE_UPDATE_COUNTRYCODE';

//Actions
export const ACTIONS_UPDATE_ZIPCODE = 'shared/ACTIONS_UPDATE_ZIPCODE';
export const ACTIONS_UPDATE_CONTAINER_LIST = 'shared/ACTIONS_UPDATE_CONTAINER_LIST';
export const ACTIONS_UPDATE_CART_LIST = 'shared/ACTIONS_UPDATE_CART_LIST';
export const ACTIONS_UPDATE_CART_CUSTOMATTRIBUTE = 'shared/ACTIONS_UPDATE_CART_CUSTOMATTRIBUTE';
export const ACTIONS_UPDATE_CART_CSCSURVEY = 'shared/ACTIONS_UPDATE_CART_CSCSURVEY';
export const ACTIONS_DELETE_CART_CSCSURVEY = 'shared/ACTIONS_DELETE_CART_CSCSURVEY';
export const ACTIONS_REMOVE_CARTITEM = 'shared/ACTIONS_REMOVE_CARTITEM';
export const ACTIONS_UPDATE_RESETCART = 'shared/ACTIONS_UPDATE_RESETCART';
export const ACTIONS_UPDATE_TYPE = 'shared/ACTIONS_UPDATE_TYPE';
export const ACTIONS_UPDATE_PURPOSE = 'shared/ACTIONS_UPDATE_PURPOSE';
export const ACTIONS_UPDATE_DELIVERY = 'shared/ACTIONS_UPDATE_DELIVERY';
export const ACTIONS_UPDATE_CSC_TERMS = 'shared/ACTIONS_UPDATE_CSC_TERMS';
export const ACTIONS_UPDATE_CSC_SURVEY = 'shared/ACTIONS_UPDATE_CSC_SURVEY';
export const ACTIONS_UPDATE_CURRENTSURVEYOBJECT = 'shared/ACTIONS_UPDATE_CURRENTSURVEYOBJECT';
export const ACTIONS_UPDATE_CURRENTSURVEY_PURPOSE = 'shared/MUTATE_UPDATE_CURRENTSURVEY_PURPOSE';
export const ACTIONS_UPDATE_CURRENTSURVEY_TYPE = 'shared/MUTATE_UPDATE_CURRENTSURVEY_TYPE';
export const ACTIONS_UPDATE_TERMSCHECKBOX = 'shared/ACTIONS_UPDATE_TERMSCHECKBOX';
export const ACTIONS_UPDATE_LINEITEMHAULERPRICE = 'shared/ACTIONS_UPDATE_LINEITEMHAULERPRICE';
export const ACTIONS_UPDATE_LINEITEMMARKET = 'shared/MUTATE_UPDATE_LINEITEMMARKET';
export const ACTIONS_UPDATE_PREDELIVERYANSWERS = 'shared/ACTIONS_UPDATE_PREDELIVERYANSWERS';
export const ACTIONS_UPDATE_DELIVERY_DOORDIRECTION = 'shared/ACTIONS_UPDATE_DELIVERY_DOORDIRECTION';
export const ACTIONS_UPDATE_DELIVERY_SPACE = 'shared/ACTIONS_UPDATE_DELIVERY_SPACE';
export const ACTIONS_UPDATE_DELIVERY_RUSTACKNOWLEDGE = 'shared/ACTIONS_UPDATE_DELIVERY_RUSTACKNOWLEDGE';
export const ACTIONS_UPDATE_DELIVERY_INSTRUCTIONS = 'shared/ACTIONS_UPDATE_DELIVERY_INSTRUCTIONS';
export const ACTIONS_UPDATE_DELIVERY_NAME = 'shared/ACTIONS_UPDATE_DELIVERY_NAME';
export const ACTIONS_UPDATE_DELIVERY_PHONE = 'shared/ACTIONS_UPDATE_DELIVERY_PHONE';
export const ACTIONS_UPDATE_DELIVERY_NONACCEPTABLEDATES = 'shared/ACTIONS_UPDATE_DELIVERY_NONACCEPTABLEDATES';
export const ACTIONS_UPDATE_DELIVERY_SURFACETYPE = 'shared/ACTIONS_UPDATE_DELIVERY_SURFACETYPE';
export const ACTIONS_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE = 'shared/ACTIONS_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE';
export const ACTIONS_UPDATE_PREPICKUPANSWERS = 'shared/ACTIONS_UPDATE_PREPICKUPANSWERS';
export const ACTIONS_UPDATE_PICKUP_RUSTACKNOWLEDGE = 'shared/ACTIONS_UPDATE_PICKUP_RUSTACKNOWLEDGE';
export const ACTIONS_UPDATE_PICKUP_INSPECTION = 'shared/ACTIONS_UPDATE_PICKUP_INSPECTION';
export const ACTIONS_UPDATE_PICKUP_INSTRUCTIONS = 'shared/ACTIONS_UPDATE_PICKUP_INSTRUCTIONS';
export const ACTIONS_UPDATE_PICKUP_NAME = 'shared/ACTIONS_UPDATE_PICKUP_NAME';
export const ACTIONS_UPDATE_FEEDBACKGIVEN = 'shared/ACTIONS_UPDATE_FEEDBACKGIVEN';
export const ACTIONS_UPDATE_COUNTRYCODE = 'shared/ACTIONS_UPDATE_COUNTRYCODE';
export const ACTIONS_CALCULATE_RTOAMOUNT = 'shared/ACTIONS_CALCULATE_RTOAMOUNT';